import { Loading } from "@socar-inc/frontend-design-system";
import { WithPageContainer } from "@src/containers/WithPageContainer";
import { useHideActionBar } from "@src/hooks/useHideActionBar";
import Script from "next/script";
import { useState } from "react";
import { ChatbotNavigator } from "./ChatbotNavigator";

export default function ChatBot() {
  const [isReady, setIsReady] = useState(false);

  useHideActionBar({
    dependencies: [isReady],
    retentionSite: ["about:blank", "https://webchat.thecloudgate.io", "/"]
  });

  const setChatbotReady = () => {
    setIsReady(true);
  };

  return (
    <WithPageContainer>
      <Loading style={{ zIndex: -1 }} />
      <Script
        src="https://public-sdk.thecloudgate.io/sdk/cloud/Twc.plugin.js"
        onReady={setChatbotReady}
      ></Script>
      <ChatbotNavigator isReady={isReady} />
    </WithPageContainer>
  );
}
